import { createTablePageSlice } from "../helpers/createTablePageSlice";

export const TicketsSlice = createTablePageSlice({
  reducerName: "tickets",
  getListEndpoint: "v1/admin/bookings/tickets",
  configs: {
    availableSearchParams: ["id", "code", "event"],
  },
});
